import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × ROLEX: Chronometric perfection
// Dial grids, mechanical symmetry, temporal lines
export function VasarelyRolexMode({ brand }: ModeRendererProps) {
  const rolexGreen = "#006039";
  const rolexGold = "#D4AF37";

  return (
    <g>
      {/* Signature green background */}
      <rect x="0" y="0" width="794" height="1123" fill={rolexGreen} opacity="0.95" />

      <g transform="translate(397 540)">
        {/* Dial grid (watch face precision) */}
        {Array.from({ length: 60 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 60;
          const isHour = i % 5 === 0;
          const r1 = isHour ? 200 : 210;
          const r2 = 230;
          
          return (
            <line
              key={i}
              x1={Math.cos(angle) * r1}
              y1={Math.sin(angle) * r1}
              x2={Math.cos(angle) * r2}
              y2={Math.sin(angle) * r2}
              stroke={rolexGold}
              strokeWidth={isHour ? 3 : 1}
              opacity={isHour ? 0.8 : 0.4}
            />
          );
        })}

        {/* Mechanical symmetry (gear inspiration) */}
        {Array.from({ length: 8 }).map((_, ring) => {
          const r = 60 + ring * 20;
          const teeth = 12 + ring * 4;
          
          return (
            <g key={ring}>
              {Array.from({ length: teeth }).map((_, i) => {
                const angle = (i * Math.PI * 2) / teeth;
                const x = Math.cos(angle) * r;
                const y = Math.sin(angle) * r;
                
                return (
                  <rect
                    key={i}
                    x={x - 3}
                    y={y - 3}
                    width="6"
                    height="6"
                    fill={rolexGold}
                    opacity="0.3"
                    transform={`rotate(${(angle * 180) / Math.PI} ${x} ${y})`}
                  />
                );
              })}
            </g>
          );
        })}

        {/* Temporal lines (time flow) */}
        {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          return (
            <line
              key={angle}
              x1="0"
              y1="0"
              x2={Math.cos(rad) * 180}
              y2={Math.sin(rad) * 180}
              stroke={rolexGold}
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Oyster case circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 50 + i * 18;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={rolexGold}
              strokeWidth="1.5"
              opacity={0.3 - i * 0.018}
            />
          );
        })}

        {/* Perpetual motion nodes */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 160;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="10"
                fill={rolexGold}
                opacity="0.5"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="15"
                fill="none"
                stroke={rolexGold}
                strokeWidth="2"
                opacity="0.4"
              />
            </g>
          );
        })}

        {/* Central crown */}
        <circle cx="0" cy="0" r="35" fill={rolexGold} opacity="0.3" />
        <circle cx="0" cy="0" r="35" fill="none" stroke={rolexGold} strokeWidth="3" opacity="0.7" />
        
        {/* Crown points */}
        {[0, 72, 144, 216, 288].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * 28}
              cy={Math.sin(rad) * 28}
              r="5"
              fill={brand.green}
              opacity="0.6"
            />
          );
        })}
      </g>

      {/* Rolex text */}
      <text x="397" y="95" textAnchor="middle" fontFamily="serif" fontWeight="600" fontSize="13" fill={rolexGold} opacity="0.8">
        PERFECTION CHRONOMÉTRIQUE
      </text>
    </g>
  );
}
